<template>
    <div class="btn" @click="clicked">
        <p>{{ buttonLabel.toUpperCase() }}</p>
        <i class="fas fa-redo-alt" :class="{ 'animated': animated }"></i>
    </div>
</template>

<script>
export default {
  props: {
    animated: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      buttonLabel: 'Refresh'
    }
  },
  methods: {
    clicked () {
      this.$emit('refresh-button-clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn {
    position: absolute;
    left: 0 ; right: 0; bottom: 0;
    z-index: 100;
    display: flex;
    -webkit-display: flex;
    width: 90%;
    max-width: 400px;
    height: 50px;
    border: none;
    border-radius: 30px;
    -webkit-border-radius: 30px;
    letter-spacing: .5px;
    font-size: 16px;
    color: white;
    font-weight: 700;
    background-color: #464A53;
    margin: 10px auto;
    box-shadow: 0px 5px 5px 1px darkgray;

    i {
      font-size: 30px;
      position: absolute;
      top: 50%;
      left: 10%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform-origin: center;

      &.animated {
        animation: rotating 1s linear infinite;
        -webkit-animation: rotating 1s linear infinite;
      }
    }

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      -webkit-display: flex;
      -webkit-align-items: center;
      -webkit-justify-content: center;
      margin: 0px;
      width: 100%;
    }
  }

  @keyframes rotating {
    from {
      transform: translate(-50%, -50%) rotate(0deg);
      -webkit-transform: translate(-50%, -50%) rotate(0deg);
    }
    to {
      transform: translate(-50%, -50%) rotate(360deg);
      -webkit-transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @media screen and (max-width: 320px) {
    .btn {
      height: 40px;
      font-size: 14px;

      i {
        font-size: 25px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/buttons/Refresh.vue